import axios from 'axios';

const api = axios.create({
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});

// request가 발생했을 때 실행될 interceptors를 추가
api.interceptors.request.use(
  (config) => {
    // config.method를 조회하여 get 메서드일 때만 timeout을 설정
    // if (config.method === 'get') {
    //     config.timeout = 12000;
    // }
    return config;
  },
  (error) => {
    //console.log(error);
  },
);

// 응답 인터셉터 추가하기
api.interceptors.response.use(
  function (response) {
    // 2xx 범위에 있는 상태 코드는 이 함수를 트리거
    // 응답 데이터가 있는 작업 수행
    return response;
  },
  function (error) {
    // 2xx 외의 범위에 있는 상태 코드는 이 함수를 트리거
    // 응답 오류가 있는 작업 수행

    const code = error.code;
    const status = error.response?.status;

    // timeout이 발생한 경우와 서버에서 408 에러를 반환할 때를 동시에 처리
    if (code === 'ECONNABORTED' || status === 408) {
      alert('요청이 만료되었습니다.');
    }
    return Promise.reject(error);
  },
);

export default api;
